import { lazy } from '@/service/lazy'

export default [{
  name: 'Pedido Novo',
  path: 'pedido/:id/:novo',
  id: 'pedido',
  props: true,
  component: lazy('app/default/pedido/index'),
  meta: { requireAuth: true, rules: ['atender_cliente'] },
  children: []
},
{
  name: 'Pedido',
  path: 'pedido/:id',
  id: 'pedido',
  props: true,
  component: lazy('app/default/pedido/index'),
  meta: { requireAuth: true, rules: ['atender_cliente'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/pedido.js